<div class="icon-marker__circle" [style.background]="color">
  <div class="icon-marker__inner">S</div>
</div>
<div class="c-marker__label-wrapper">
    <div class="c-marker__label" [style.background]="color">
        {{time()}}
    </div>
</div>
<i class="icon-marker-arrow" [style.transform]="'rotate(' + data.bearing + 'deg)'" [style.color]="color"></i>
